<div class="or-px-12-px" [fullHeightScrollableContainer]="115">
  @if (invitations(); as invitations) {
    @if (!invitations.availableToInvite?.length) {
      <ng-container
        *ngTemplateOutlet="
          invitationsUnavailable;
          context: {
            adjustCenter: !invitations.availableToInvite?.length && !invitations.invited?.length
          }
        "></ng-container>
    }
    @if (invitations.availableToInvite?.length) {
      <div
        class="or-d-flex or-justify-content-between or-mb-16-px or-mt-24-px or-head-sm or-align-items-center or-mx-8-px">
        <div class="or-color-secondary-2">Lista dawnych graczy</div>
        <div class="or-d-flex or-justify-content-between or-align-items-center">
          <div>Zaznacz wszystkich</div>
          <ion-checkbox [checked]="false" (ionChange)="selectAll($event)" class="or-ml-8-px"></ion-checkbox>
        </div>
      </div>
    }
    @for (player of invitations.availableToInvite; track player.userId; let i = $index) {
      <div
        class="or-bg-white or-d-flex or-justify-content-between or-p-8-px or-mb-4-px player-box border-radius-8"
        [class.border-primary]="player.isSelected"
        [class.or-bg-selected]="player.isSelected">
        <div class="or-d-flex or-align-items-center or-w-100-pc" (click)="selectPlayer(player.userId)">
          <ion-checkbox [checked]="player.isSelected" class="or-mr-8-px"></ion-checkbox>
          <lib-or-avatar
            [avatarUrl]="player.thumbnail"
            [initials]="player.displayName"
            [avatarSize]="'sm'"></lib-or-avatar>

          <div class="or-head-sm or-d-flex or-align-items-center">
            {{ i + 1 }}.&nbsp;
            <span class="or-truncate-at-line-1">{{ player.displayName }}</span>
          </div>
        </div>
      </div>
    }
    @if (invitations.invited?.length) {
      <div class="or-d-flex or-justify-content-between or-mb-16-px or-mt-32-px or-head-sm or-mx-8-px">
        <div class="or-color-secondary-2">Już zaproszeni</div>
        <div></div>
      </div>

      @for (player of invitations.invited; track player.userId; let i = $index) {
        <div class="or-d-flex or-justify-content-between or-p-8-px or-mb-4-px player-box border-radius-8">
          <div class="or-d-flex or-align-items-center">
            <ion-checkbox [checked]="true" class="or-mr-8-px" disabled></ion-checkbox>
            <lib-or-avatar
              [avatarUrl]="player.thumbnail"
              [initials]="player.displayName"
              [avatarSize]="'sm'"></lib-or-avatar>

            <div class="or-head-sm or-d-flex or-align-items-center or-w-100-pc">
              {{ i + 1 }}.&nbsp;<span class="or-truncate-at-line-1">{{ player.displayName }}</span>
            </div>
          </div>
        </div>
      }
    }
  }
</div>

@if (showInviteButton()) {
  <div class="or-mx-12-px or-mb-12-px">
    <button
      (click)="sendInvitations()"
      class="button-primary-style or-h-48-px or-head-md or-w-100-pc"
      [class.disabled-button]="!hasSelectedUsers()">
      Zaproś graczy
    </button>
  </div>
}

<ng-template #invitationsUnavailable let-adjustCenter="adjustCenter">
  <div
    class="or-mt-32-px or-text-align-center or-text-md"
    [class.or-h-100-pc]="adjustCenter"
    [class.or-align-content-center]="adjustCenter">
    <div>Tu możesz zaprosić graczy z poprzednich gier.</div>
    <div class="or-mt-12-px">Zaproś graczy do obecnej gry za pomocą linku.</div>

    @if (gameDetails(); as game) {
      <button class="button-primary-style or-h-48-px or-w-90-pc or-head-md or-mb-12-px or-mt-32-px" [shareGame]="game">
        <div class="or-align-items-center or-d-flex or-justify-content-center">
          <or-icon name="copy-link" size="m" class="or-color-white or-mr-12-px" />

          <span class="or-mr-12-px">Skopiuj link</span>
        </div>
      </button>
    }
  </div>
</ng-template>
